import { Show } from "solid-js";
import { useI18n } from "../i18n/provider.tsx";
import { coverageRatio, formatCoverage, type Coverage } from "../lib/format.ts";
import styles from "./CoverageBar.module.scss";

export type CoverageBarProps = Coverage & {
  hideLabel?: boolean;
};

/** Makes thin data visible instead of letting it hide inside an average. */
export const CoverageBar = (props: CoverageBarProps) => {
  const i18n = useI18n();
  const coverage = (): Coverage => ({ answered: props.answered, total: props.total });
  const text = () => formatCoverage(coverage(), i18n.locale());

  return (
    <div class={styles.wrapper}>
      <div
        class={styles.track}
        role="meter"
        aria-label={i18n.t().common.coverage}
        aria-valuemin={0}
        aria-valuemax={props.total}
        aria-valuenow={props.answered}
        aria-valuetext={text()}
      >
        <div class={styles.fill} style={{ "--ratio": `${coverageRatio(coverage())}` }} />
      </div>
      <Show when={props.hideLabel !== true}>
        <span class={styles.label}>{text()}</span>
      </Show>
    </div>
  );
};
